import { CrudTable, StatusBadge } from "@/components/shared";

export default function Testimonials() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "person", label: "By" },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "type", label: "Type", render: (r) => <StatusBadge value={r.type} /> },
    { key: "source", label: "Source" },
    { key: "link_or_notes", label: "Link / Notes" },
  ];
  const fields = [
    { key: "date", label: "Date", type: "date" },
    { key: "patient_name", label: "Patient Name", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "type", label: "Type", type: "select", options: ["Written", "Video"] },
    { key: "source", label: "Source", type: "select", options: ["Google", "In-clinic", "WhatsApp", "Instagram", "Other"] },
    { key: "link_or_notes", label: "Link / Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable testid="testimonials" endpoint="testimonials" dateField="date"
      title="Testimonials"
      subtitle="Written ya video testimonials — source aur link ke saath record karo."
      columns={columns} fields={fields} defaults={{ type: "Written" }} />
  );
}
